var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserBlueBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.725,
    height: 38.725,
    viewBox: "0 0 38.725 38.725",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_217",
    "data-name": "Trazado 217",
    d: "M761.4,584.193a19.362,19.362,0,1,0,19.362,19.362A19.37,19.37,0,0,0,761.4,584.193Zm0,5.808a5.809,5.809,0,1,1-5.808,5.808A5.8,5.8,0,0,1,761.4,590Zm0,27.494a13.938,13.938,0,0,1-11.617-6.235c.057-3.853,7.745-5.964,11.617-5.964,3.854,0,11.56,2.111,11.618,5.964A13.941,13.941,0,0,1,761.4,617.5Z",
    transform: "translate(-742.035 -584.193)",
    fill: "#85d4ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserBlueBig);
export default __webpack_public_path__ + "static/media/user-blue-big.233dc24c451841450aead0bf4a51bfd3.svg";
export { ForwardRef as ReactComponent };